import { type FormRevision, type Stored } from "@overmap-ai/common"
import { selectAttachmentsOfFormRevision } from "@overmap-ai/core"
import { FieldsRenderer } from "@overmap-ai/forms"
import { cx } from "class-variance-authority"
import { type ComponentProps, memo } from "react"

import { sdk } from "../../sdk"
import { useShallowEqaulSelector } from "../../store"
import { useDeserializeFieldSchemaConfig, useFieldSchemaFromConfig, useHydrateFieldsWithAttachments } from "./hooks"

interface FormSubmitterProps extends Omit<ComponentProps<typeof FieldsRenderer>, "fieldSchema"> {
	formRevision: Stored<FormRevision>
}

export const FormSubmitter = memo<FormSubmitterProps>((props) => {
	const { className, formRevision, ...rest } = props

	const attachments = useShallowEqaulSelector(selectAttachmentsOfFormRevision(formRevision.uuid))

	const fieldSchemaConfig = useDeserializeFieldSchemaConfig(formRevision.fields)

	const fieldSchemaConfigWithImages = useHydrateFieldsWithAttachments(
		fieldSchemaConfig,
		attachments,
		sdk.formRevisionAttachments,
	)
	const fieldSchema = useFieldSchemaFromConfig(fieldSchemaConfigWithImages)

	return <FieldsRenderer className={cx(className, "h-max w-full")} fieldSchema={fieldSchema} {...rest} />
})

FormSubmitter.displayName = "FormSubmitter"
